module.exports = __webpack_public_path__ + "img/2011-11_bloomberg.85692cd9.png";